var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.6,
    height: 74.6,
    viewBox: "0 0 74.6 74.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "appointment-new-svgrepo-com",
    d: "M30.306,0a30.306,30.306,0,0,0,0,60.613c.783,0,1.566-.036,2.331-.091V51.16a19.783,19.783,0,0,1-2.331.127A20.981,20.981,0,1,1,51.288,30.306a19.782,19.782,0,0,1-.127,2.331h9.361c.055-.765.091-1.548.091-2.331A30.377,30.377,0,0,0,30.306,0Zm0,13.988a2.324,2.324,0,0,0-2.331,2.331V27.975H20.981a2.331,2.331,0,0,0,0,4.663h9.325a2.324,2.324,0,0,0,2.331-2.331V16.319A2.324,2.324,0,0,0,30.306,13.988ZM51.288,37.3V51.288H37.3v9.325H51.288V74.6h9.325V60.613H74.6V51.288H60.613V37.3Zm0,0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentIconMobile);
export default __webpack_public_path__ + "static/media/appointmentIconMobile.22cf3b02f87520a684c3abf6d811f27c.svg";
export { ForwardRef as ReactComponent };